import React, { Component } from 'react';
import { Redirect } from 'react-router'
import renderHTML from 'react-render-html';
import Menu from './Menu'
import Post from './Post'
import RedSocial from './redsocial'
import Contact from './contact'

import { connect } from 'react-redux'
import { initLocation, initMenuAsync, PostCategoryAsync, PagebySlug, PostbyCategorySlug, initPostClear } from './actions'


class App extends Component {
  constructor(props){
    super(props)
    this.state = {
      pageObj:[],
      menu:[],
      redirect: false,
      starndarpos: false,
      catidPro: 6,
      tagidPro: 12,
      excludeContry:['VE'],
      excludeCountryID:[19],
      excludeCountryInterID:[22],
      menuexclude: false,
      menuSel:'',
      countryId:0,
      titleStandar: '',
      starndarcontact: false
    }
  }

  componentDidMount(){
    this.props.getLocation()
    this.props.getMenuInit()
    this.props.getPage(this.props.match.params.pagePath)

    if(this.props.match.params.pagePath === 'quienes-somos'){
      this.setState({
        starndarpost: true,
        titleStandar: 'Sobre Nosotros'
      });
    }
    if(this.props.match.params.pagePath === 'contacto'){
      this.setState({
        starndarpost: true,
        titleStandar: 'Contacto'
      });
    }
    if(this.props.match.params.pagePath === 'search'){
      this.setState({
        redirect: true,
        titleStandar: 'search'
      });
    }
    const validate = 'contacto'
    if(this.props.match.params.pagePath.includes(validate)){
      this.setState({
        starndarpost: true,
        titleStandar: 'Contacto',
        starndarcontact: true
      });
    }
  }

  componentWillReceiveProps(next_props) {
    if(next_props.country.location !== this.state.country){
      this.setState({
        country: next_props.country.location,
        menuSel: `menu-${next_props.country.idtag.slug}`
      });
      let nameMenu = `menu-${next_props.country.idtag.slug}`
      let idCo = next_props.country.idtag.term_id
      this.setState({
        country: next_props.country.location,
        menuSel: nameMenu,
        tagidLoc: next_props.country.idtag.term_id,
        defaultCountry: idCo,
        selectDest: [],
        selectBrand: [],
        selectCase: []
      })
      this.props.clearPost()
    }

    if(next_props.pageObj !== this.state.pageObj){
      this.setState({
        pageObj: next_props.pageObj
      });
    }   
  }

  render() {
    if (this.state.redirect && this.state.titleStandar === 'search'){
      return <Redirect to='/search/%20'/>;
    }

    if (this.state.redirect && !this.state.contacto){
      return <Redirect to='/error/404'/>;
    }

    return (
      <div className={'cont_detail ' + this.state.titleStandar}>
        <header className="App-header">
          <div className="">
            <div className="row">
              <div className="col s12 m11 offset-m1 l7 offset-l5 logo">
                <Contact search={false}/>
                <RedSocial search={true}/>
                <Menu slug='locations' select={true}col={12} scrollMenu={false} changeGeo={true} defCountry={this.state.defaultCountry}/>
              </div>
              <div className="col s12 m12 l12 nav_principal">
                <Menu slug={this.state.menuSel}  col={12} scrollMenu={true}/>
              </div>
            </div>
          </div>
        </header>
        <section>
          <div className="col s12 ">
            <div className="container">
              <div className="row">
                <div className="col s12 m12 l12">
                { this.state.starndarpost && !this.state.starndarcontact &&
                  <Post content={this.state.pageObj} title_cat={this.state.titleStandar} classColor="bg_color_new_s"/>
                }

                { this.state.starndarpost && this.state.starndarcontact &&
                  <Post content={this.state.pageObj} title_cat={this.state.titleStandar} classColor="bg_color_new_s" contact={true} geo={this.state.country}/>
                }

                {
                  !this.state.starndarpost &&
                  this.state.pageObj.map((item, i) => {  
                    return (
                      <div className="item-post" key={i}>
                        <div className="row">
                          { item.video_field.length > 0 &&
                            <div className="wrapper-player">
                              <div className="player">
                                <iframe src={item.video_field} title={item.title.rendered} frameborder="0"></iframe>
                              </div>
                            </div>
                          }
                          { item.featured_media > 0 &&
                            <div className="col s12 m12 l12">
                              <div className={(item.video_field !== '' && item.video_field !== undefined && item.video_field.length > 0) ? 'item-post-img-play' : 'item-post-img'}>
                                <a href={item.link}><img src={item.media.media_details.sizes.medium.source_url} alt=""/></a>
                              </div>
                            </div>
                          }
                          { item.featured_media > 0 &&
                            <div className="col s12 m12 l12">
                              <div className="item-post-cont">
                                <div>{renderHTML(item.content.rendered)}</div>
                              </div>
                            </div>
                          }
                          { item.featured_media === 0 &&
                            <div className="col s12 m12 l12">
                              <div className="item-post-cont">
                                <div>{renderHTML(item.content.rendered)}</div>
                              </div>
                            </div>
                          } 
                        </div>
                      </div>
                    )
                  })
                }
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer>
          <div className="line_bg"></div>
          <div className="cont_log_footer">
            <div className="container">
              <div className="row">
                <div className="col s12 m7 text_vc">
                  <p>COPYRIGHT @ VC MEDIOS S.A. 2018 > TODOS LOS DERECHOS RESERVADOS</p>
                  <p><a href="/terminos-y-condiciones-politica-de-privacidad/">TERMINOS Y CONDICIONES</a> | <a href="/terminos-y-condiciones-politica-de-privacidad/">POLITICAS DE PRIVACIDAD</a></p>
                </div>
                <div className="col s12 m5 brand_vc">
                  <img className="col s6" src="/assets/images/logo_vc_footer_b.png"  alt=""/>
                  <img className="col s6" src="/assets/images/logo_vcDigital_footer_b.png"  alt=""/>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}


function mapStateToProps (reducer){
  return {
    menus: reducer.menus,
    pageObj: reducer.pages,
    country: reducer.country
  }
}

function mapDispathToProps (dispatch){
  return {
    getLocation: (data) => dispatch(initLocation(data)),
    getAllCategorybyId: (data) => dispatch(PostbyCategorySlug(data)),
    getMenuInit: (data) => dispatch(initMenuAsync(data)),
    getCategory: (data) => dispatch(PostCategoryAsync(data)),
    getPage: (data) => dispatch(PagebySlug(data)),
    clearPost: (data) => dispatch(initPostClear(data)),
  }
}

export default connect(mapStateToProps, mapDispathToProps)(App)



// WEBPACK FOOTER //
// ./src/Page.js